"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mapObject;
function mapObject(object, mapper) {
  return Object.keys(object).reduce(function (result, key) {
    result[key] = mapper(object[key], key);
    return result;
  }, {});
}
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/radium/lib/map-object.js
 ** module id = 435
 ** module chunks = 0
 **/